import { render, staticRenderFns } from "./SearchCarousel.vue?vue&type=template&id=6ab9387f&"
import script from "./SearchCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab9387f')) {
      api.createRecord('6ab9387f', component.options)
    } else {
      api.reload('6ab9387f', component.options)
    }
    module.hot.accept("./SearchCarousel.vue?vue&type=template&id=6ab9387f&", function () {
      api.rerender('6ab9387f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8NcUdKRGtx5ed/JS/SearchCarousel.vue"
export default component.exports